import { cn } from '../../lib/utils'

// ─── Illustrations ────────────────────────────────────────────────────────────
const CalendarIllustration = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10" y="16" width="60" height="54" rx="8" fill="#f0eaff"/>
    <rect x="10" y="16" width="60" height="16" rx="8" fill="#e8e4f0"/>
    <rect x="10" y="24" width="60" height="8" fill="#e8e4f0"/>
    <rect x="20" y="8" width="6" height="16" rx="3" fill="#7c6faf"/>
    <rect x="54" y="8" width="6" height="16" rx="3" fill="#7c6faf"/>
    <rect x="20" y="42" width="10" height="10" rx="3" fill="#2d1b5e" opacity="0.15"/>
    <rect x="35" y="42" width="10" height="10" rx="3" fill="#2d1b5e" opacity="0.3"/>
    <rect x="50" y="42" width="10" height="10" rx="3" fill="#2d1b5e" opacity="0.15"/>
    <rect x="20" y="56" width="10" height="10" rx="3" fill="#2d1b5e" opacity="0.15"/>
    <rect x="35" y="56" width="10" height="10" rx="3" fill="#2d1b5e" opacity="0.15"/>
  </svg>
)

const TasksIllustration = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="12" width="56" height="56" rx="8" fill="#f0eaff"/>
    <rect x="24" y="26" width="32" height="6" rx="3" fill="#e8e4f0"/>
    <rect x="24" y="38" width="24" height="6" rx="3" fill="#e8e4f0"/>
    <rect x="24" y="50" width="28" height="6" rx="3" fill="#e8e4f0"/>
    <circle cx="19" cy="29" r="4" fill="#2d1b5e" opacity="0.2"/>
    <circle cx="19" cy="41" r="4" fill="#2d1b5e" opacity="0.35"/>
    <path d="M16.5 41l2 2 3-3" stroke="#2d1b5e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.8"/>
    <circle cx="19" cy="53" r="4" fill="#2d1b5e" opacity="0.2"/>
  </svg>
)

const RecipesIllustration = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="30" fill="#f0eaff"/>
    <path d="M28 34c0-6.6 5.4-12 12-12s12 5.4 12 12c0 5-3 9.3-7.3 11.2L43 58H37l-1.7-12.8C31 43.3 28 39 28 34z" fill="#e8e4f0"/>
    <path d="M36 22v-6M40 22v-8M44 22v-6" stroke="#7c6faf" strokeWidth="2" strokeLinecap="round"/>
    <rect x="35" y="48" width="10" height="4" rx="2" fill="#7c6faf" opacity="0.5"/>
    <rect x="36" y="54" width="8" height="4" rx="2" fill="#7c6faf" opacity="0.4"/>
  </svg>
)

const NotesIllustration = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="14" y="10" width="44" height="56" rx="6" fill="#f0eaff"/>
    <rect x="14" y="10" width="44" height="12" rx="6" fill="#e8e4f0"/>
    <rect x="14" y="16" width="44" height="6" fill="#e8e4f0"/>
    <rect x="22" y="30" width="28" height="4" rx="2" fill="#2d1b5e" opacity="0.2"/>
    <rect x="22" y="38" width="24" height="4" rx="2" fill="#2d1b5e" opacity="0.15"/>
    <rect x="22" y="46" width="20" height="4" rx="2" fill="#2d1b5e" opacity="0.15"/>
    <rect x="22" y="54" width="14" height="4" rx="2" fill="#2d1b5e" opacity="0.1"/>
    <circle cx="58" cy="58" r="10" fill="#2d1b5e"/>
    <path d="M54 58h8M58 54v8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

const ShoppingIllustration = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12" y="20" width="56" height="46" rx="8" fill="#f0eaff"/>
    <path d="M28 20c0-6.6 5.4-12 12-12s12 5.4 12 12" stroke="#7c6faf" strokeWidth="3" strokeLinecap="round"/>
    <rect x="22" y="34" width="26" height="4" rx="2" fill="#e8e4f0"/>
    <rect x="22" y="44" width="22" height="4" rx="2" fill="#e8e4f0"/>
    <rect x="22" y="54" width="18" height="4" rx="2" fill="#e8e4f0"/>
    <circle cx="18" cy="36" r="3" fill="#2d1b5e" opacity="0.25"/>
    <circle cx="18" cy="46" r="3" fill="#2d1b5e" opacity="0.25"/>
    <circle cx="18" cy="56" r="3" fill="#2d1b5e" opacity="0.25"/>
  </svg>
)

const ILLUSTRATIONS = {
  calendar: CalendarIllustration,
  tasks:    TasksIllustration,
  recipes:  RecipesIllustration,
  notes:    NotesIllustration,
  shopping: ShoppingIllustration,
}

// ─── EmptyState ───────────────────────────────────────────────────────────────
export const EmptyState = ({ type = 'tasks', title, description, action, className }) => {
  const Illustration = ILLUSTRATIONS[type] ?? TasksIllustration
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 px-6 text-center', className)}>
      <div className="mb-5">
        <Illustration />
      </div>
      {title && <p className="text-sm font-semibold text-text-primary mb-1">{title}</p>}
      {description && <p className="text-xs text-text-muted max-w-xs leading-relaxed">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  )
}
